// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cs-container {
  padding: 24px 0px;
  max-width: 1400px;
  margin: 0 auto;
  overflow: visible;
}

/* стили для блока фильтров */
.cs-filters {
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  margin-bottom: 32px;
  overflow: visible;
  position: relative; 
  z-index: 1; 
}

.cs-actions-row {
  display: flex;
  justify-content: flex-start;
  gap: 12px;
  padding-bottom: 20px;
}

.cs-filters-row {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  align-items: flex-end;
  overflow: visible;
}

.cs-filter-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 200px;
  position: relative; 
  overflow: visible; 
}

.cs-filter-group label {
  font-weight: 500;
  color: #444;
  font-size: 14px;
}

.cs-input, .cs-select {
  padding: 10px 12px;
  border: 1px solid #e0e5ec;
  border-radius: 8px;
  font-size: 14px;
  transition: border-color 0.2s;
  background: white;
}

.cs-input:focus, .cs-select:focus {
  outline: none;
  border-color: #002FA7;
}

.cs-teacher-search {
  display: flex;
  gap: 8px;
}

.cs-teacher-search .cs-input {
  flex: 1 1;
}

.cs-time-range, .cs-pair-range {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
}

.cs-time-range .cs-input {
  width: 120px;
}

.cs-pair-range .cs-select {
  width: 100px;
}

.cs-schedule-list {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  overflow-x: visible;
  overflow-y: visible;
  position: relative;
  width: 120%;
  margin-left: -0,5%; 
  left: 50%;
  transform: translateX(-50%);
}


/* Для таблицы внутри */
.cs-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 12px;
  font-size: 13px;
  padding: 10px;
}

.cs-table th {
  background: #f8faff;
  padding: 12px 8px;
  text-align: left;
  font-weight: 600;
  color: #002FA7;
  border-bottom: 2px solid #e0e5ec;
  font-size: 13px;
  white-space: nowrap;
  position: relative; /* Добавлено */
}

.cs-table td {
  padding: 12px 8px;
  border-bottom: 1px solid #eef2f6;
  vertical-align: middle;
  position: relative; 
  overflow: visible;
}

.cs-pair-row:hover {
  background: #fafbff;
}

.cs-teacher-name {
  font-size: 12px;
  color: #666;
  margin-top: 2px;
}

.cs-subject-cell {
  max-width: 300px;
  white-space: normal;
  word-wrap: break-word;
  font-size: 12px; 
  line-height: 1.4;
}

.cs-change-cell {
  min-width: 200px;
  position: relative;
  overflow: visible; 
}

.cs-change-select, .cs-room-select {
  width: 100%;
  padding: 6px 8px;
  border: 1px solid #e0e5ec;
  border-radius: 6px;
  font-size: 12px;
}

.cs-actions {
  display: flex;
  gap: 4px;
}

.cs-btn {
  padding: 6px 8px;
  border: none;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.cs-btn-save {
  background: #002FA7;
  color: white;
}

.cs-btn-save:hover {
  background: #001f7a;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 47, 167, 0.2);
}

.cs-btn-notwill {
  background: #f2f6fe;
  color: #002FA7;
}

.cs-btn-notwill:hover {
  background: #f2f6fe;
}

.cs-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.cs-title {
  font-size: 28px;
  font-weight: 600;
  color: #002FA7;
  margin: 0;
}

.cs-header-actions {
  display: flex;
  gap: 12px;
}

.cs-btn-view, .cs-btn-add {
  background: white;
  color: #002FA7;
  border: 1px solid #002FA7;
  padding: 10px 16px;
  font-size: 14px;
  font-weight: 450;
}

.cs-btn-view:hover, .cs-btn-add:hover {
  background: #f0f3ff;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 47, 167, 0.1);
}

.cs-empty {
  text-align: center;
  padding: 60px 20px;
  background: white;
  border-radius: 12px;
  color: #888;
  font-size: 16px;
}

.cs-loading {
  text-align: center;
  padding: 40px;
  color: white;
  font-size: 16px;
}

/* стили для страницы добавления пары */
.add-pair-container {
  padding: 24px 0px;
  max-width: 1400px;
  margin: 0 auto;
  overflow: visible;
}

/* верхний блок */
.add-pair-header-block {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  margin-bottom: 24px;
  padding: 16px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
  width: 100%;
  box-sizing: border-box;
  overflow: visible; 
}

.add-pair-date-info {
  display: flex;
  gap: 30px;
  flex-wrap: wrap;
}

.date-info-input {
  padding: 8px 12px;
  border: 1px solid #e0e5ec;
  border-radius: 6px;
  font-size: 14px;
  background: white;
  min-width: 150px;
  margin-left: 5px;
}

.date-info-input:focus {
  outline: none;
  border-color: #002FA7;
}

.add-pair-nav {
  display: flex;
  align-items: center;
}

/* нижний блок */
.add-pair-form-block {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  padding: 24px;
  width: 100%;
  box-sizing: border-box;
  overflow: visible; 
}

.add-pair-form {
  padding: 0;
  overflow: visible;
}

.form-section {
  margin-bottom: 32px;
  background: white;
  border-radius: 8px;
  padding: 20px;
  overflow: visible; 
}

.form-section h3 {
  font-size: 18px;
  color: #002FA7;
  margin: 0 0 20px 0;
  padding-bottom: 10px;
  border-bottom: 1px solid #e0e5ec;
}

.form-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 24px;
  margin-bottom: 20px;
  overflow: visible; 
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;
  overflow: visible;
}

.form-group label {
  font-weight: 500;
  color: #444;
  font-size: 14px;
}

.required {
  color: #dc3545;
  margin-left: 4px;
}

.form-control {
  padding: 12px;
  border: 1px solid #e0e5ec;
  border-radius: 8px;
  font-size: 14px;
  background: white;
  transition: all 0.2s;
}

.form-control:focus {
  outline: none;
  border-color: #002FA7;
  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);
}

.form-control:disabled {
  background: #f5f5f5;
  cursor: not-allowed;
}

.form-hint {
  font-size: 12px;
  margin-top: 4px;
}

.form-hint.warning {
  color: #dc3545;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid #eef2f6;
}

.btn {
  padding: 12px 28px;
  border: none;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-primary {
  background: #002FA7;
  color: white;
}

.btn-primary:hover {
  background: #001f7a;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.2);
}

.btn-primary:disabled {
  background: #cccccc;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.btn-secondary {
  background: #f2f6fe;
  color: #002FA7;
}

.btn-secondary:hover {
  background: #e5eaff;
  transform: translateY(-1px);
}

/* стили для SearchableSelect */
.searchable-select-wrapper {
  position: relative;
  display: inline-block;
  width: 100%;
  overflow: visible; 
}

.searchable-select-trigger {
  width: 100%;
  text-align: left;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  background-color: white;
}

.searchable-select-label {
  flex: 1 1;
  text-align: left;
  font-size: 14px; 
}

.searchable-select-trigger:hover {
  border-color: #002FA7;
}

.searchable-select-trigger:focus {
  outline: none;
  border-color: #002FA7;
  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);
}

.searchable-select-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #e0e5ec;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 9999;
  overflow: hidden;
  margin-top: 4px;
  min-width: 100%;
  width: auto;
}

/* Стиль для выпадающего списка, когда он открывается вверх */
.searchable-select-dropdown.dropup {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: 4px;
}

.searchable-select-list {
  max-height: 220px;
  overflow-y: auto;
  margin: 0;
  padding: 4px 0;
  list-style: none;
}

.searchable-select-option {
  padding: 8px 12px;
  font-size: 14px;
  cursor: pointer;
  color: #333;
  transition: background-color 0.2s;
}

.searchable-select-option:hover {
  background-color: #f2f6fe;
}

.searchable-select-option.selected {
  background-color: #e8f0fe;
  color: #002FA7;
  font-weight: 500;
}

.searchable-select-option.no-results {
  color: #999;
  font-style: italic;
  cursor: default;
  text-align: center;
}

.searchable-select-option.no-results:hover {
  background-color: transparent;
}

.cs-disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
  opacity: 0.6;
}

body {
  overflow-x: hidden;
}

.portal-dropdown {
  position: fixed !important;
  z-index: 10000 !important;
}`, "",{"version":3,"sources":["webpack://./src/md-components/ChangesScheduleSection.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA,6BAA6B;AAC7B;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,2BAA2B;AAC7B;;;AAGA,uBAAuB;AACvB;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,mBAAmB;EACnB,kBAAkB,EAAE,cAAc;AACpC;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA,uCAAuC;AACvC;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,WAAW;EACX,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA,6DAA6D;AAC7D;EACE,SAAS;EACT,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B","sourcesContent":[".cs-container {\n  padding: 24px 0px;\n  max-width: 1400px;\n  margin: 0 auto;\n  overflow: visible;\n}\n\n/* стили для блока фильтров */\n.cs-filters {\n  background: white;\n  border-radius: 12px;\n  padding: 20px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n  margin-bottom: 32px;\n  overflow: visible;\n  position: relative; \n  z-index: 1; \n}\n\n.cs-actions-row {\n  display: flex;\n  justify-content: flex-start;\n  gap: 12px;\n  padding-bottom: 20px;\n}\n\n.cs-filters-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n  align-items: flex-end;\n  overflow: visible;\n}\n\n.cs-filter-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 200px;\n  position: relative; \n  overflow: visible; \n}\n\n.cs-filter-group label {\n  font-weight: 500;\n  color: #444;\n  font-size: 14px;\n}\n\n.cs-input, .cs-select {\n  padding: 10px 12px;\n  border: 1px solid #e0e5ec;\n  border-radius: 8px;\n  font-size: 14px;\n  transition: border-color 0.2s;\n  background: white;\n}\n\n.cs-input:focus, .cs-select:focus {\n  outline: none;\n  border-color: #002FA7;\n}\n\n.cs-teacher-search {\n  display: flex;\n  gap: 8px;\n}\n\n.cs-teacher-search .cs-input {\n  flex: 1;\n}\n\n.cs-time-range, .cs-pair-range {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n}\n\n.cs-time-range .cs-input {\n  width: 120px;\n}\n\n.cs-pair-range .cs-select {\n  width: 100px;\n}\n\n.cs-schedule-list {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n  overflow-x: visible;\n  overflow-y: visible;\n  position: relative;\n  width: 120%;\n  margin-left: -0,5%; \n  left: 50%;\n  transform: translateX(-50%);\n}\n\n\n/* Для таблицы внутри */\n.cs-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  border-radius: 12px;\n  font-size: 13px;\n  padding: 10px;\n}\n\n.cs-table th {\n  background: #f8faff;\n  padding: 12px 8px;\n  text-align: left;\n  font-weight: 600;\n  color: #002FA7;\n  border-bottom: 2px solid #e0e5ec;\n  font-size: 13px;\n  white-space: nowrap;\n  position: relative; /* Добавлено */\n}\n\n.cs-table td {\n  padding: 12px 8px;\n  border-bottom: 1px solid #eef2f6;\n  vertical-align: middle;\n  position: relative; \n  overflow: visible;\n}\n\n.cs-pair-row:hover {\n  background: #fafbff;\n}\n\n.cs-teacher-name {\n  font-size: 12px;\n  color: #666;\n  margin-top: 2px;\n}\n\n.cs-subject-cell {\n  max-width: 300px;\n  white-space: normal;\n  word-wrap: break-word;\n  font-size: 12px; \n  line-height: 1.4;\n}\n\n.cs-change-cell {\n  min-width: 200px;\n  position: relative;\n  overflow: visible; \n}\n\n.cs-change-select, .cs-room-select {\n  width: 100%;\n  padding: 6px 8px;\n  border: 1px solid #e0e5ec;\n  border-radius: 6px;\n  font-size: 12px;\n}\n\n.cs-actions {\n  display: flex;\n  gap: 4px;\n}\n\n.cs-btn {\n  padding: 6px 8px;\n  border: none;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  white-space: nowrap;\n}\n\n.cs-btn-save {\n  background: #002FA7;\n  color: white;\n}\n\n.cs-btn-save:hover {\n  background: #001f7a;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(0, 47, 167, 0.2);\n}\n\n.cs-btn-notwill {\n  background: #f2f6fe;\n  color: #002FA7;\n}\n\n.cs-btn-notwill:hover {\n  background: #f2f6fe;\n}\n\n.cs-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n}\n\n.cs-title {\n  font-size: 28px;\n  font-weight: 600;\n  color: #002FA7;\n  margin: 0;\n}\n\n.cs-header-actions {\n  display: flex;\n  gap: 12px;\n}\n\n.cs-btn-view, .cs-btn-add {\n  background: white;\n  color: #002FA7;\n  border: 1px solid #002FA7;\n  padding: 10px 16px;\n  font-size: 14px;\n  font-weight: 450;\n}\n\n.cs-btn-view:hover, .cs-btn-add:hover {\n  background: #f0f3ff;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(0, 47, 167, 0.1);\n}\n\n.cs-empty {\n  text-align: center;\n  padding: 60px 20px;\n  background: white;\n  border-radius: 12px;\n  color: #888;\n  font-size: 16px;\n}\n\n.cs-loading {\n  text-align: center;\n  padding: 40px;\n  color: white;\n  font-size: 16px;\n}\n\n/* стили для страницы добавления пары */\n.add-pair-container {\n  padding: 24px 0px;\n  max-width: 1400px;\n  margin: 0 auto;\n  overflow: visible;\n}\n\n/* верхний блок */\n.add-pair-header-block {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n  margin-bottom: 24px;\n  padding: 16px 24px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 20px;\n  width: 100%;\n  box-sizing: border-box;\n  overflow: visible; \n}\n\n.add-pair-date-info {\n  display: flex;\n  gap: 30px;\n  flex-wrap: wrap;\n}\n\n.date-info-input {\n  padding: 8px 12px;\n  border: 1px solid #e0e5ec;\n  border-radius: 6px;\n  font-size: 14px;\n  background: white;\n  min-width: 150px;\n  margin-left: 5px;\n}\n\n.date-info-input:focus {\n  outline: none;\n  border-color: #002FA7;\n}\n\n.add-pair-nav {\n  display: flex;\n  align-items: center;\n}\n\n/* нижний блок */\n.add-pair-form-block {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n  padding: 24px;\n  width: 100%;\n  box-sizing: border-box;\n  overflow: visible; \n}\n\n.add-pair-form {\n  padding: 0;\n  overflow: visible;\n}\n\n.form-section {\n  margin-bottom: 32px;\n  background: white;\n  border-radius: 8px;\n  padding: 20px;\n  overflow: visible; \n}\n\n.form-section h3 {\n  font-size: 18px;\n  color: #002FA7;\n  margin: 0 0 20px 0;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #e0e5ec;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 24px;\n  margin-bottom: 20px;\n  overflow: visible; \n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  position: relative;\n  overflow: visible;\n}\n\n.form-group label {\n  font-weight: 500;\n  color: #444;\n  font-size: 14px;\n}\n\n.required {\n  color: #dc3545;\n  margin-left: 4px;\n}\n\n.form-control {\n  padding: 12px;\n  border: 1px solid #e0e5ec;\n  border-radius: 8px;\n  font-size: 14px;\n  background: white;\n  transition: all 0.2s;\n}\n\n.form-control:focus {\n  outline: none;\n  border-color: #002FA7;\n  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);\n}\n\n.form-control:disabled {\n  background: #f5f5f5;\n  cursor: not-allowed;\n}\n\n.form-hint {\n  font-size: 12px;\n  margin-top: 4px;\n}\n\n.form-hint.warning {\n  color: #dc3545;\n}\n\n.form-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 16px;\n  margin-top: 32px;\n  padding-top: 24px;\n  border-top: 1px solid #eef2f6;\n}\n\n.btn {\n  padding: 12px 28px;\n  border: none;\n  border-radius: 8px;\n  font-size: 15px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btn-primary {\n  background: #002FA7;\n  color: white;\n}\n\n.btn-primary:hover {\n  background: #001f7a;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.2);\n}\n\n.btn-primary:disabled {\n  background: #cccccc;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.btn-secondary {\n  background: #f2f6fe;\n  color: #002FA7;\n}\n\n.btn-secondary:hover {\n  background: #e5eaff;\n  transform: translateY(-1px);\n}\n\n/* стили для SearchableSelect */\n.searchable-select-wrapper {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  overflow: visible; \n}\n\n.searchable-select-trigger {\n  width: 100%;\n  text-align: left;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: space-between;\n  box-sizing: border-box;\n  background-color: white;\n}\n\n.searchable-select-label {\n  flex: 1;\n  text-align: left;\n  font-size: 14px; \n}\n\n.searchable-select-trigger:hover {\n  border-color: #002FA7;\n}\n\n.searchable-select-trigger:focus {\n  outline: none;\n  border-color: #002FA7;\n  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);\n}\n\n.searchable-select-dropdown {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background: white;\n  border: 1px solid #e0e5ec;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  z-index: 9999;\n  overflow: hidden;\n  margin-top: 4px;\n  min-width: 100%;\n  width: auto;\n}\n\n/* Стиль для выпадающего списка, когда он открывается вверх */\n.searchable-select-dropdown.dropup {\n  top: auto;\n  bottom: 100%;\n  margin-top: 0;\n  margin-bottom: 4px;\n}\n\n.searchable-select-list {\n  max-height: 220px;\n  overflow-y: auto;\n  margin: 0;\n  padding: 4px 0;\n  list-style: none;\n}\n\n.searchable-select-option {\n  padding: 8px 12px;\n  font-size: 14px;\n  cursor: pointer;\n  color: #333;\n  transition: background-color 0.2s;\n}\n\n.searchable-select-option:hover {\n  background-color: #f2f6fe;\n}\n\n.searchable-select-option.selected {\n  background-color: #e8f0fe;\n  color: #002FA7;\n  font-weight: 500;\n}\n\n.searchable-select-option.no-results {\n  color: #999;\n  font-style: italic;\n  cursor: default;\n  text-align: center;\n}\n\n.searchable-select-option.no-results:hover {\n  background-color: transparent;\n}\n\n.cs-disabled {\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\nbody {\n  overflow-x: hidden;\n}\n\n.portal-dropdown {\n  position: fixed !important;\n  z-index: 10000 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
